// ProgressTracker.js

import React from "react";
import "./ProgressTracker.scss";


import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const ProgressTracker = ({ steps, currentStep  }) => {
  return (
    <div className="progress-tracker">
      <Box sx={{ 
        width: '100%',
        overflowX: 'auto',
        '&::-webkit-scrollbar': {
          height: '4px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#888',
          borderRadius: '2px',
        },
      }}>
        <Stepper 
          activeStep={currentStep} 
          alternativeLabel
          sx={{
            minWidth: steps.length > 4 ? `${steps.length * 40}px` : '100%',
          }}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </div>
  );
}

export default ProgressTracker;
